import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { formatDate } from "@/utils/content";

export default function NewsStrip() {
  const items = news.slice(0, 5);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center gap-2 border-b border-background-200 px-4 py-3 md:px-5">
        <span className="flex h-6 w-6 items-center justify-center rounded bg-accent-500 text-secondary-950">
          <i className="ri-flashlight-line text-sm" />
        </span>
        <span className="font-heading text-sm font-semibold text-foreground-950">最新影视资讯</span>
        <span className="hidden text-xs text-foreground-400 sm:inline">
          · 每日更新剧集动态
        </span>
        <Link
          to="/category/news"
          className="ml-auto inline-flex items-center gap-1 whitespace-nowrap text-xs text-primary-700 transition-colors hover:text-primary-900"
        >
          全部资讯
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
      <ul className="divide-y divide-background-100">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:px-5"
            >
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
              <span className="min-w-0 flex-1 truncate text-sm text-foreground-700 transition-colors group-hover:text-primary-700">
                {item.title}
              </span>
              <span className="hidden shrink-0 text-xs text-foreground-400 md:inline">
                {formatDate(item.date)}
              </span>
              <i className="ri-arrow-right-s-line shrink-0 text-foreground-300 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}